import React from 'react';
import { Helmet } from 'react-helmet';
import {
  FaChalkboardTeacher,
  FaGraduationCap,
  FaBook,
  FaLaptopCode,
  FaChartLine,
  FaShieldAlt
} from 'react-icons/fa';
import SEO from '../../components/SEO';


const DigitalLearningSolutions = () => {
  return (
      <>
    <SEO title="Digital Learning Solutions" />
    <div className="py-12 px-4 max-w-7xl mx-auto text-gray-800">
      <Helmet>
        <title>Digital Learning Solutions | AKHSoft</title>
        <meta
          name="description"
          content="Transform your educational experience with AKHSoft's Digital Learning Solutions. We build powerful, scalable, and interactive platforms for schools, universities, and enterprises."
        />
      </Helmet>

      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-[#0a3c6d] mb-4">
          Digital Learning Solutions
        </h1>
        <p className="text-lg max-w-3xl mx-auto text-gray-600">
          Empower educators, engage learners, and transform classrooms with AKHSoft’s customized digital learning platforms. We provide scalable, interactive, and secure e-learning solutions tailored for schools, universities, and corporate training needs.
        </p>
      </div>

      <div className="grid md:grid-cols-2 gap-10">
        {/* Feature 1 */}
        <div className="flex items-start space-x-5">
          <FaChalkboardTeacher className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Interactive Virtual Classrooms
            </h3>
            <p className="text-gray-700">
              Deliver live sessions with real-time whiteboards, screen sharing, quizzes, and attendance tracking — making remote education more interactive and engaging.
            </p>
          </div>
        </div>

        {/* Feature 2 */}
        <div className="flex items-start space-x-5">
          <FaGraduationCap className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              LMS Integration & Content Management
            </h3>
            <p className="text-gray-700">
              Manage curriculum, courses, multimedia resources, and progress reports with a powerful learning management system tailored to your institution's needs.
            </p>
          </div>
        </div>

        {/* Feature 3 */}
        <div className="flex items-start space-x-5">
          <FaBook className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Digital Libraries & Self-Learning Modules
            </h3>
            <p className="text-gray-700">
              Offer 24/7 access to eBooks, tutorials, recorded lectures, and personalized learning paths to promote continuous, self-paced learning.
            </p>
          </div>
        </div>

        {/* Feature 4 */}
        <div className="flex items-start space-x-5">
          <FaLaptopCode className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Exam & Assignment Automation
            </h3>
            <p className="text-gray-700">
              Conduct secure online assessments, assignments, and automated grading with anti-cheating mechanisms and detailed analytics.
            </p>
          </div>
        </div>

        {/* Feature 5 */}
        <div className="flex items-start space-x-5">
          <FaChartLine className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Progress Tracking & Analytics
            </h3>
            <p className="text-gray-700">
              Monitor learner performance with dashboards, progress charts, and reports to ensure every student stays on the right learning path.
            </p>
          </div>
        </div>

        {/* Feature 6 */}
        <div className="flex items-start space-x-5">
          <FaShieldAlt className="text-[#0a3c6d] text-4xl mt-1" />
          <div>
            <h3 className="text-xl font-semibold text-[#0a3c6d]">
              Secure & Scalable Architecture
            </h3>
            <p className="text-gray-700">
              Deploy solutions built with enterprise-grade security, GDPR compliance, and scalability to handle thousands of users concurrently.
            </p>
          </div>
        </div>
      </div>

      {/* CTA */}
      <div className="mt-16 text-center">
        <h3 className="text-2xl font-semibold text-[#0a3c6d] mb-4">
          Ready to Launch Your Digital Learning Platform?
        </h3>
        <p className="text-gray-700 mb-6 max-w-2xl mx-auto">
          Whether you're an educational institute or a corporate trainer, AKHSoft is your partner in building high-performance digital learning solutions tailored to your needs.
        </p>
        <a
          href="/contact"
          className="inline-block bg-[#0a3c6d] text-white py-3 px-6 rounded-lg hover:bg-blue-900 transition"
        >
          Get a Free Consultation
        </a>
      </div>
    </div>
    </>
  );
};

export default DigitalLearningSolutions;
